var map = {
	"./aquarium.png": 614,
	"./beach.png": 615,
	"./butterflies.png": 616,
	"./fields.png": 617,
	"./garden.png": 618,
	"./island.png": 619,
	"./lake.png": 620,
	"./numbers.png": 621,
	"./relax_on_the_beach.png": 622,
	"./river.png": 623,
	"./sound_of_water.png": 624,
	"./sunset.png": 625,
	"./universe.png": 626,
	"./waves.png": 627
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 613;